<div class="survey-container">

  <!-- ===== PANTALLA DE CONFIRMACIÓN ===== -->
  <div *ngIf="enviado" class="text-center py-5">
    <div style="font-size:4rem;">✅</div>
    <h2 class="survey-title mt-3">¡Datos enviados!</h2>
    <p class="survey-desc mt-2">
      Tu respuesta ha sido registrada correctamente.<br>
      <strong>¡Gracias por tu participación!</strong>
    </p>
    <button class="submit-button mt-4" (click)="enviado = false">
      Responder de nuevo
    </button>
  </div>

  <!-- ===== FORMULARIO ===== -->
  <ng-container *ngIf="!enviado && encuesta">

  <!-- HEADER -->
  <div class="survey-header text-center mb-4">

    <img [src]="'assets/images/logos/' + nitEmpresa + '/logo.png'" class="survey-logo">

    <h2 class="survey-title">{{ encuesta.titulo }}</h2>

    <p *ngIf="encuesta.descripcion" class="survey-desc">
      {{ encuesta.descripcion }}
    </p>

    <div class="progress-container mt-3">
      <div class="progress">
        <div class="progress-bar" [style.width.%]="progreso"></div>
      </div>
      <small>{{ progreso | number:'1.0-0' }}% completado</small>
    </div>

  </div>

  <!-- DATOS DEL RESPONDIENTE -->
  <div class="question-card mb-4">
    <div class="question-header mb-3">
      <div class="question-number">👤</div>
      <div class="question-text">Datos de identificación</div>
    </div>
    <div class="row g-3">
      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold">Nombre completo <span class="text-danger">*</span></label>
        <input type="text" class="form-control modern-input"
          placeholder="Ej: Juan Pérez"
          [(ngModel)]="nombre_respondente"
          maxlength="100">
      </div>
      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold">Placa del vehículo <span class="text-danger">*</span></label>

        <!-- Selector cuando vienen placas por parámetro -->
        <select *ngIf="listadoPlacas.length > 0"
          class="form-select modern-input"
          [(ngModel)]="placa_vehiculo">
          <option value="" disabled>Selecciona tu placa...</option>
          <option *ngFor="let p of listadoPlacas" [value]="p">{{ p }}</option>
        </select>

        <!-- Input libre cuando no hay listado -->
        <input *ngIf="listadoPlacas.length === 0"
          type="text" class="form-control modern-input"
          placeholder="Ej: ABC123"
          [(ngModel)]="placa_vehiculo"
          maxlength="10"
          [readonly]="placaDesdeQr"
          style="text-transform: uppercase;">
      </div>
    </div>
  </div>

  <!-- PREGUNTAS -->

  <div *ngFor="let pregunta of encuesta.preguntas; let i = index"
       class="question-card"
       [class.answered]="esRespondida(i)"
       [class.invalid]="submitted && !esRespondida(i) && (pregunta.tipo === 'seleccion_unica' || pregunta.tipo === 'seleccion_multiple')">

      <div class="question-header">

        <div class="question-number">
          {{ i + 1 }}
        </div>

        <div class="question-text">
          {{ pregunta.texto }}
        </div>

      </div>


      <!-- RESPUESTA ABIERTA -->

      <textarea *ngIf="pregunta.tipo === 'abierta'"
        class="form-control modern-input"
        rows="3"
        placeholder="Escribe tu respuesta..."
        [(ngModel)]="getRespuesta(i).respuesta_texto">
      </textarea>


      <!-- SELECCION UNICA -->

      <div *ngIf="pregunta.tipo === 'seleccion_unica'" class="options">

        <label *ngFor="let opcion of pregunta.opciones"
               class="option-card checkbox-option"
               [class.selected]="getRespuesta(i).respuesta_opcion === opcion.id">

          <input type="radio"
                 [name]="'pregunta_' + i"
                 [value]="opcion.id"
                 [checked]="getRespuesta(i).respuesta_opcion === opcion.id"
                 (change)="getRespuesta(i).respuesta_opcion = opcion.id"
                 class="me-2" />
          {{ opcion.texto }}

        </label>

      </div>
      <div *ngIf="submitted && !esRespondida(i) && pregunta.tipo === 'seleccion_unica'" class="validation-msg">
        <i class="fa fa-exclamation-circle me-1"></i>Debes seleccionar una opción.
      </div>


      <!-- MULTIPLE -->

      <div *ngIf="pregunta.tipo === 'seleccion_multiple'" class="options">

        <label *ngFor="let opcion of pregunta.opciones"
               class="option-card checkbox-option"
               [class.selected]="isOpcionSeleccionada(i, opcion.id!)">

          <input type="checkbox"
                 [checked]="isOpcionSeleccionada(i, opcion.id!)"
                 (change)="toggleOpcionMultiple(i, opcion.id!)"
                 class="me-2" />
          {{ opcion.texto }}

        </label>

      </div>
      <div *ngIf="submitted && !esRespondida(i) && pregunta.tipo === 'seleccion_multiple'" class="validation-msg">
        <i class="fa fa-exclamation-circle me-1"></i>Debes seleccionar al menos una opción.
      </div>


      <!-- ESCALA -->

      <div *ngIf="pregunta.tipo === 'escala'" class="scale-container">

        <button *ngFor="let n of [1,2,3,4,5]"
          class="scale-btn"
          [class.active]="getRespuesta(i).respuesta_escala === n"
          (click)="getRespuesta(i).respuesta_escala = n">

          {{ n }}

        </button>

      </div>


      <!-- SI NO -->

      <div *ngIf="pregunta.tipo === 'si_no'" class="yes-no">

        <button
          class="yes-btn"
          [class.active]="getRespuesta(i).respuesta_si_no === true"
          (click)="getRespuesta(i).respuesta_si_no = true">
          👍 Si
        </button>

        <button
          class="no-btn"
          [class.active]="getRespuesta(i).respuesta_si_no === false"
          (click)="getRespuesta(i).respuesta_si_no = false">
          👎 No
        </button>

      </div>

  </div>


  <!-- BOTON -->

  <div class="text-center mt-4">

    <button class="submit-button"
      (click)="enviarRespuestas()"
      [disabled]="isEnviando">

      {{ isEnviando ? 'Enviando...' : 'Enviar encuesta' }}

    </button>

  </div>

  </ng-container>

  <div *ngIf="!enviado && isLoading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Cargando encuesta...</span>
    </div>
    <p class="survey-desc mt-3 mb-0">Cargando encuesta...</p>
  </div>

  <div *ngIf="!enviado && !isLoading && errorMsg" class="text-center py-5">
    <h2 class="survey-title mt-3">No se pudo cargar la encuesta</h2>
    <p class="survey-desc mt-2">{{ errorMsg }}</p>
  </div>

</div>
